export default __webpack_public_path__ + "static/media/letter-i.cdb9fe40.png";